import React from "react";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { ServicesCarousel } from "../components/ServicesCarousel";
import { Process } from "../components/Process";
import { Proof } from "../components/Proof";
import { Insights } from "../components/Insights";
import { Consultation } from "../components/Consultation";
import { Footer } from "../components/Footer";
import { useScrollReveal } from "../hooks/useScrollReveal";
export function Home() {
  useScrollReveal();
  return <div className="w-full bg-white" data-id="element-323" data-mp="24htqah802qh1">
      <Hero data-id="element-324" data-mp="24ivbheiqctch" />
      <main data-id="element-325" data-mp="29gdbugiom08v">
        <About data-id="element-326" data-mp="29flqdyistiwb" />
        <ServicesCarousel data-id="element-327" data-mp="29f282gp8kshr" />
        <Process data-id="element-328" data-mp="29etu0lhdnh4z" />
        <Proof data-id="element-329" data-mp="29ihqnti4cjnx" />
        <Insights data-id="element-330" data-mp="2dhgrb1wthu9k" />
        <Consultation data-id="element-331" data-mp="2dhywwp5ddku5" />
      </main>
      <Footer data-id="element-332" data-mp="2dj9wsdvp28fz" />
    </div>;
}